module.exports = __webpack_public_path__ + "static/media/screen1.952f0a64.jpeg";